export default __webpack_public_path__ + "static/media/settings_icon_white.3ef09d1e.svg";